import { render } from "./CraList.vue?vue&type=template&id=7a8e5b80&scoped=true"
import script from "./CraList.js?vue&type=script&lang=js"
export * from "./CraList.js?vue&type=script&lang=js"

import "./CraList.vue?vue&type=style&index=0&id=7a8e5b80&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a8e5b80"]])

export default __exports__